module.exports = __webpack_public_path__ + "img/guide-en-2.4a59c9c9.png";